import { Injectable } from "@angular/core";
import { IVitalProfileDefinition } from "@comunicare/comunicare-interfaces";
import { Observable } from "rxjs";
import { VitalProfileDefinitionApiService } from "../providers/api/vital-profile-definition-api.service";

@Injectable({
  providedIn: "root",
})
export class VitalProfileDefinitionsService {
  constructor(private api: VitalProfileDefinitionApiService) {}

  public list(patientId: string, careplanRef?: string): Observable<IVitalProfileDefinition[]> {
    return this.api.list(patientId, careplanRef);
  }
}
